import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { post } from '../api/base';
import { isInternalUser } from "../../app/config/config";

export const useQuestionnaire = () => {
  const { user } = useSelector(({ auth }) => ({ user: auth.user }));
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [questionnaireCompleted, setQuestionnaireCompleted] = useState(false);

  useEffect(() => {
    if (user && user.id) {
      checkQuestionnaireStatus();
    }
  }, [user]);

  const checkQuestionnaireStatus = async () => {
    try {
      
      const response = await post('questionnaire/SaveQuestionnaire', {
        jsonBody: {
          user_id: user.id
        }
      });

      // Se sono un utente interno non mostro il questionario  
      if (isInternalUser(parseInt(user.idRole))) {
        setQuestionnaireCompleted(true);
        setShowQuestionnaire(false);
        
        setIsChecking(false);
        
        return {
          showQuestionnaire,
          questionnaireCompleted,
          isChecking,
          handleQuestionnaireComplete,
          forceShowQuestionnaire
        };
      }

      

      if ((response && response.success)) {
        
        setQuestionnaireCompleted(response.completed);
        // Mostra il questionario solo se non è stato completato
        
        setShowQuestionnaire(!response.completed);
      }
    } catch (error) {
      console.error('Errore nel controllo del questionario:', error);
      // In caso di errore, mostra comunque il questionario per sicurezza
      setShowQuestionnaire(true);
    } finally {
      setIsChecking(false);
    }
  };

  const handleQuestionnaireComplete = () => {
    setQuestionnaireCompleted(true);
    setShowQuestionnaire(false);
  };

  const forceShowQuestionnaire = () => {
    setShowQuestionnaire(true);
  };

  return {
    showQuestionnaire,
    questionnaireCompleted,
    isChecking,
    handleQuestionnaireComplete,
    forceShowQuestionnaire
  };
};